import { createStyles } from '@/styles';

export default createStyles(() => ({
  classes: {
    footerRoot: 'flex justify-between items-center w-full text-xs text-fg-subtle',
  },
  styles: {
    footerRoot: {},
  },
}));
